import { Button } from '@/components/ui/Button';

/** Before the first analysis: what the qualification is for, and one way in. */
export const QualificationIntro = ({ onStart }: { onStart: () => void }) => (
  <section className="mx-auto max-w-2xl py-16 text-center">
    <h2 className="font-display text-3xl font-semibold leading-tight text-domino-ink">Ce que Domino doit savoir de votre entreprise</h2>
    <p className="mt-4 text-base leading-7 text-domino-inkSoft">
      L’analyste lit votre site, votre CRM et vos documents, puis vous pose quelques questions.
      Il en tire ce qui limite aujourd’hui votre chiffre d’affaires, les objectifs à suivre
      et les applications à créer pour votre équipe.
    </p>
    <Button className="mt-8" onClick={onStart}>Commencer l’analyse</Button>
  </section>
);
